export const fiatCurrencies = ['USD', 'EUR', 'NOK', 'SEK', 'DKK', 'GBP', 'JPY', 'AUD', 'CAD', 'CHF']
